import { Injectable } from '@angular/core';

import { OverridesProvider } from './overrides-provider';
import { UserGridColumnOverrides } from '../model/user-grid-column-overrides';

@Injectable()
export class OverridesRelayService implements OverridesProvider {
    private provider: OverridesProvider | undefined;

    getCurrentGridColumnOverrides(
        widgetOnBoardId?: number,
        visualizationId?: number,
        vizType?: string,
    ): UserGridColumnOverrides[] {
        if (!this.provider) {
            throw new Error('cannot provide overrides without linking to another provider');
        }

        if (!widgetOnBoardId || visualizationId == null || !vizType) {
            return [];
        }

        return this.provider.getCurrentGridColumnOverrides(widgetOnBoardId, visualizationId, vizType);
    }

    link(provider: OverridesProvider): void {
        this.provider = provider;
    }
}
